export default "__VITE_ASSET__kM7WF5TS__"